import React, { useState } from 'react';
import { ImagePreview } from './ImagePreview';

const initialZoomState = { zoomedIn: false, isLeft: true, keepZoomOpen: false };

export const CompareImagePreview = React.memo(function CompareImagePreview({
  url,
  compareUrl,
  zoom = true,
  left = false,
  ...props
}) {
  const [zoomState, setZoomState] = useState(initialZoomState);

  if (!compareUrl) {
    return <ImagePreview url={url} zoom={zoom} {...props} />;
  }

  return (
    <span className="inline-block position-relative">
      <ImagePreview
        url={url}
        zoom={zoom}
        left={!left}
        onStateChange={setZoomState}
        {...props}
      />
      {zoomState.zoomedIn && (
        <ImagePreview
          url={compareUrl}
          zoom={zoom}
          hideThumb
          forceZoomedIn
          // Always the half opposite the main image, so Alt-flipping the main overlay
          // (see ImagePreview) drags the comparison to the freed side.
          left={!zoomState.isLeft}
        />
      )}
    </span>
  );
});
